import ReviewConfirmPage from './reviewConfirmPage';

export default ReviewConfirmPage;